import React, { useState, useEffect } from "react";
import "./MultiCarouselSelect.css";

//around the world images
import spainImage from "assets/places_images/around_the_world/Spain.png";
import swedenImage from "assets/places_images/around_the_world/Sweden.png";
import japanImage from "assets/places_images/around_the_world/Japan.png";
import franceImage from "assets/places_images/around_the_world/France.png";
import alaskaImage from "assets/places_images/around_the_world/Alaska.png";
import hawaiiImage from "assets/places_images/around_the_world/Hawaii.png";
import chinaImage from "assets/places_images/around_the_world/China.png";
import malaysiaImage from "assets/places_images/around_the_world/Malaysia.png";
import costaRicaImage from "assets/places_images/around_the_world/Costa_Rica.png";
import newYorkImage from "assets/places_images/around_the_world/New_york.png";
import washingtonDCImage from "assets/places_images/around_the_world/Washington_DC.png";
import englandImage from "assets/places_images/around_the_world/England.png";
import tanzaniaImage from "assets/places_images/around_the_world/Tanzania.png";
import californiaImage from "assets/places_images/around_the_world/California.png";
import coloradoImage from "assets/places_images/around_the_world/Colorado.png";

import theHillCampusImage from "assets/places_images/campus/The_Hill.png";

import dormLoungeImage from "assets/places_images/campus/Dorm_Lounge.png";
import labImage from "assets/places_images/campus/Lab.png";
import stadiumImage from "assets/places_images/campus/Stadium.png";
import stageImage from "assets/places_images/campus/Stage.png";
import mallImage from "assets/places_images/campus/The_Mall.png";

// carousel navigation icons

import {ReactComponent as CarouselLeftArrow} from "assets/icons/Carousel-arrow-left.svg";
import {ReactComponent as CarouselRightArrow} from "assets/icons/Carousel-arrow-right.svg";

function MultiCarouselSelect({ optionSelectCallback, carouselSelectCallback, ct}) {
  const [isCarouselVisible, setIsCarouselVisible] = useState(ct !== "");
  const [currentOptions, setCurrentOptions] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState("");

  const [carouselHeader, setCarouselHeader] = useState("");
  const [carouselDisclaimer, setCarouselDisclaimer] = useState("");

  const optionsPerPage = 6;

  //listen to change in carousel type to set carousel visibility
  useEffect(() => {
    setIsCarouselVisible(ct !== "");
    if(ct === "") setSelectedOption("");
  }, [ct]);

  
  const showCarousel = (carouselType) => {
    setIsCarouselVisible(true);
    carouselSelectCallback(carouselType);
    
    //GTM push for carousel type
    window.dataLayer.push({
      event: "GustiebotSteps",
      stepnumber: "4 your future",
      characteristic: carouselType,
    });

    if (carouselType === "campus") {
      //source campusOptions
      setCarouselHeader("On Campus");
      setCarouselDisclaimer("");
      const campusOptions = [
        { image: theHillCampusImage, label: "On The Hill" },
        { image: dormLoungeImage, label: "Dorm" },
        { image: stadiumImage, label: "Stadium" },
        { image: labImage, label: "Lab" },
        { image: mallImage, label: "The Mall" },
        { image: stageImage, label: "Stage" },
      ];
      setCurrentOptions(campusOptions);
    } else if (carouselType === "global") {
      //source global options
      setCarouselHeader("Around the world at real Gustavus study away sites");
      const globalOptions = [
        { image: swedenImage, label: "Sweden" },
        { image: japanImage, label: "Japan" },
        { image: franceImage, label: "France" },
        { image: spainImage, label: "Spain" },
        { image: alaskaImage, label: "Alaska" },
        { image: hawaiiImage, label: "Hawaii" },
        { image: chinaImage, label: "China" },
        { image: malaysiaImage, label: "Malaysia" },
        { image: costaRicaImage, label: "Costa Rica" },
        { image: newYorkImage, label: "New York" },
        { image: washingtonDCImage, label: "Washington D.C" },
        { image: englandImage, label: "England" },
        { image: tanzaniaImage, label: "Tanzania" },
        { image: californiaImage, label: "California" },
        { image: coloradoImage, label: "Colorado" },
      ];
      setCurrentOptions(globalOptions);
    } else {
      console.error("Invalid carousel type" + carouselType);
    }
  };

  //user clicks on a location
  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    optionSelectCallback(option);
  };

  //next/previous for the carousel images
  const handleNext = () => {
    // Prevent going beyond the available options
    if ((currentIndex + 1) * optionsPerPage < currentOptions.length) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrevious = () => {
    // Prevent going before the first page
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <>
      {isCarouselVisible ? (
        <div className="carousel-container">
          <div className="carousel-header">
            <span className="carousel-copy">
              <h4>{carouselHeader}</h4>
            </span>
            <div className={`carousel-navigation ${optionsPerPage >= currentOptions.length ? "hidden":""}`}>
              <button
                className={`carousel-prev ${
                  currentIndex > 0 ? "more-results" : ""
                }`}
                onClick={handlePrevious}
              >
                <span><CarouselLeftArrow/></span>
              </button>
              <button
                className={`carousel-next ${
                  (currentIndex + 1) * optionsPerPage < currentOptions.length
                    ? "more-results"
                    : ""
                }`}
                onClick={handleNext}
              >
                <span><CarouselRightArrow/></span>
              </button>
            </div>
          </div>
          <div className="carousel">
            {currentOptions
              .slice(currentIndex * 6, (currentIndex + 1) * 6)
              .map((option, index) => (
                <div
                  key={index}
                  className={`option ${
                    selectedOption === option.label ? "selected" : ""
                  }`}
                  onClick={() => handleOptionSelect(option.label)}
                >
                  <img src={option.image} alt={option.label} />
                  <span>{option.label}</span>
                </div>
              ))}
          </div>
        </div>
      ) : (
        <div className="image-options-carousel">
          <div className="option-container-carousel">
            <div className="option-image-container-carousel">
              <img src={theHillCampusImage} alt="The Hill" />
              <a
                className="primary button"
                onClick={() => showCarousel("campus")}
              >
                On campus
              </a>
            </div>
          </div>
          <div className="option-container-carousel">
            <div className="option-image-container-carousel">
              <img src={spainImage} alt="around the world" />
              <a
                className="primary button"
                onClick={() => showCarousel("global")}
              >
                Around the world
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default MultiCarouselSelect;
